// Creative Projects Domain - Art, writing, music, and creative endeavors
export const creativeProjectsData = {
  hub: {
    id: "hub_creative_projects",
    label: "Creative Projects",
    content: "Art, writing, music, and creative endeavors including novel writing and creative skill development",
    visibility: "ask me",
    timestamp: 1703808000000,
    category: "Domain Hub",
    level: 0,
    nodeType: "hub"
  },

  clusters: [
    {
      id: "cluster_novel_writing",
      label: "Novel Writing Project",
      content: "Fiction writing, character development, storytelling techniques, and the craft of writing",
      visibility: "ask me",
      timestamp: 1703764800000,
      category: "Project Cluster",
      level: 1,
      parentHub: "hub_creative_projects",
      nodeType: "cluster"
    },
    {
      id: "cluster_music_production",
      label: "Music & Audio",
      content: "Music production, songwriting, and audio engineering as creative outlets",
      visibility: "public",
      timestamp: 1703721600000,
      category: "Project Cluster",
      level: 1,
      parentHub: "hub_creative_projects",
      nodeType: "cluster"
    }
  ],

  areas: [
    {
      id: "area_character_development",
      label: "Character Development",
      content: "Character arcs, dialogue writing, personality building, and character-driven storytelling",
      visibility: "ask me",
      timestamp: 1703760000000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_novel_writing",
      parentHub: "hub_creative_projects",
      nodeType: "area"
    },
    {
      id: "area_plot_structure",
      label: "Plot & Structure",
      content: "Story structure, plot development, pacing, and narrative techniques",
      visibility: "ask me",
      timestamp: 1703756400000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_novel_writing",
      parentHub: "hub_creative_projects",
      nodeType: "area"
    },
    {
      id: "area_songwriting",
      label: "Songwriting",
      content: "Lyric writing, melody composition, and song structure for creative expression",
      visibility: "public",
      timestamp: 1703717200000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_music_production",
      parentHub: "hub_creative_projects",
      nodeType: "area"
    }
  ],

  mementos: [
    {
      id: "memento_025",
      label: "Character Arc: Protagonist's transformation journey",
      content: "Me: 'My main character feels flat. How do I create a compelling character arc that readers will connect with?' \n\nMapped protagonist Elena's development: Chapters 1-5 (naive idealist social worker), Ch 6-12 (disillusionment with system), Ch 13 (major betrayal by mentor), Ch 14-18 (cynical phase), Ch 19-25 (learning to trust again, finds new purpose). Key scenes: betrayal revelation, dark night of soul moment, redemption choice. Arc driven by internal conflict: idealism vs realism.",
      visibility: "ask me",
      timestamp: 1703755200000,
      category: "Creative Development",
      level: 3,
      parentArea: "area_character_development",
      parentCluster: "cluster_novel_writing",
      parentHub: "hub_creative_projects",
      subcategory: "Character Arcs",
      nodeType: "memento"
    },
    {
      id: "memento_026",
      label: "Dialogue Techniques: Subtext and character voice",
      content: "Me: 'My dialogue feels wooden and all my characters sound the same. How do I make each character's voice distinctive?' \n\nStudied dialogue techniques: each character needs distinct vocabulary, sentence structure, speech patterns. Elena (social worker): uses helping language, asks questions. Marcus (cop): short sentences, action-oriented. Key insight: subtext - characters rarely say exactly what they mean. Practice exercise: wrote same conversation from each character's POV to ensure voices stayed distinct.",
      visibility: "public",
      timestamp: 1703750400000,
      category: "Writing Technique",
      level: 3,
      parentArea: "area_character_development",
      parentCluster: "cluster_novel_writing",
      parentHub: "hub_creative_projects",
      subcategory: "Dialogue Writing",
      nodeType: "memento"
    },
    {
      id: "memento_027",
      label: "Plot Structure: Three-act breakdown with midpoint twist",
      content: "Me: 'I have all these ideas but I can't figure out how to structure them into a coherent plot. Help me organize this mess!' \n\nUsed Save the Cat beats for structure: Setup (25%), Inciting Incident, Plot Point 1 (entering new world), Midpoint twist (Elena discovers mentor's corruption), Plot Point 2 (all hope lost), Climax, Resolution. Midpoint revelation changes everything the reader thought they knew. Each act has clear purpose and escalating stakes. Much clearer roadmap now!",
      visibility: "ask me",
      timestamp: 1703746000000,
      category: "Story Structure",
      level: 3,
      parentArea: "area_plot_structure",
      parentCluster: "cluster_novel_writing",
      parentHub: "hub_creative_projects",
      subcategory: "Plot Development",
      nodeType: "memento"
    },
    {
      id: "memento_028",
      label: "Pacing Issues: Balancing action and reflection",
      content: "Me: 'Beta readers say my middle section drags. How do I keep readers engaged without non-stop action?' \n\nLearned about scene/sequel structure: Scene (goal, conflict, disaster) followed by Sequel (reaction, dilemma, decision). Problem was too many sequels in a row - characters reflecting without advancing plot. Solution: combine reflection with action, use dialogue to reveal internal thoughts, cut philosophical musings that don't serve story. Pacing much improved.",
      visibility: "ask me",
      timestamp: 1703741600000,
      category: "Writing Craft",
      level: 3,
      parentArea: "area_plot_structure",
      parentCluster: "cluster_novel_writing",
      parentHub: "hub_creative_projects",
      subcategory: "Pacing",
      nodeType: "memento"
    },
    {
      id: "memento_029",
      label: "Songwriting: Lyric writing for emotional impact",
      content: "Me: 'I can write melodies but my lyrics are terrible. How do I write lyrics that actually mean something and aren't just clichés?' \n\nLearned to start with specific images/moments rather than abstract concepts. Instead of 'love hurts,' write about 'your coffee mug still in the sink.' Use sensory details and concrete imagery. Show don't tell applies to lyrics too. Studied Leonard Cohen and Joni Mitchell for master classes in lyrical storytelling. First decent song emerged after this approach!",
      visibility: "public",
      timestamp: 1703712800000,
      category: "Lyric Writing",
      level: 3,
      parentArea: "area_songwriting",
      parentCluster: "cluster_music_production",
      parentHub: "hub_creative_projects",
      subcategory: "Songwriting Craft",
      nodeType: "memento"
    },
    {
      id: "memento_030",
      label: "Song Structure: Verse-chorus dynamics and energy",
      content: "Me: 'My songs feel flat - same energy throughout. How do I create dynamics and keep listeners engaged?' \n\nStudied energy mapping: verses build tension, choruses release it. Use contrast in melody (lower verses, higher choruses), instrumentation (sparse vs full), and dynamics (quiet vs loud). Bridge provides different perspective/key change. Learned about 'lift' - how choruses should feel like they soar compared to verses. Applied to current song with much better results.",
      visibility: "public",
      timestamp: 1703708400000,
      category: "Music Composition",
      level: 3,
      parentArea: "area_songwriting",
      parentCluster: "cluster_music_production",
      parentHub: "hub_creative_projects",
      subcategory: "Song Structure",
      nodeType: "memento"
    }
  ]
};
